import React from 'react';
import './Teachers.css';

const Teachers: React.FC = () => {
  return (
    <section id="teachers" className="teachers-section">
      {/* Top Wave */}
      <div className="teachers-wave-top">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,20 240,80 360,50 C480,20 600,80 720,50 C840,20 960,80 1080,50 C1200,20 1320,80 1440,50 L1440,0 L0,0 Z"
                fill="white" />
        </svg>
      </div>

      <div className="teachers-container">
        {/* Section Title */}
        <h2 className="teachers-title">Öğretmenlerimiz</h2>

        {/* Teachers Grid */}
        <div className="teachers-grid">
          {/* Teacher Card 1 */}
          <div className="teacher-card">
            <div className="teacher-avatar">
              <span className="teacher-initial">N</span>
            </div>
            <h3 className="teacher-name">NİHAL ÖREN</h3>
            <p className="teacher-role">Sınıf Öğretmeni</p>
            <p className="teacher-description">
              Çocuklarımızın eğitim sürecini sevgiyle yöneten, alanında uzman ve deneyimli sınıf öğretmenimiz
            </p>
            <div className="teacher-line"></div>
          </div>

          {/* Teacher Card 2 */}
          <div className="teacher-card">
            <div className="teacher-avatar">
              <span className="teacher-initial">S</span>
            </div>
            <h3 className="teacher-name">SEBAHAT BEŞİR</h3>
            <p className="teacher-role">Sınıf Öğretmeni</p>
            <p className="teacher-description">
              Çocuklarımızın gelişimini sevgiyle destekleyen, deneyimli ve sabırlı sınıf öğretmenimiz
            </p>
            <div className="teacher-line"></div>
          </div>

          {/* Teacher Card 3 */}
          <div className="teacher-card">
            <div className="teacher-avatar">
              <span className="teacher-initial">H</span>
            </div>
            <h3 className="teacher-name">HATİCE ATAŞ</h3>
            <p className="teacher-role">Sınıf Öğretmeni</p>
            <p className="teacher-description">
              Oyun temelli öğrenme yöntemleriyle çocuklarımızı geliştiren uzman eğitmenimiz
            </p>
            <div className="teacher-line"></div>
          </div>

          {/* Teacher Card 4 */}
          <div className="teacher-card">
            <div className="teacher-avatar teacher-avatar-purple">
              <span className="teacher-initial">S</span>
            </div>
            <h3 className="teacher-name">SİNEM YETKİN</h3>
            <p className="teacher-role">Uzm. Klinik Psikolog</p>
            <p className="teacher-description">
              Çocuklarımızın duygusal ve bilişsel gelişimini destekleyen, alanında uzman klinik psikologumuz
            </p>
            <div className="teacher-line teacher-line-purple"></div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="teachers-wave-bottom">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,50 C120,80 240,20 360,50 C480,80 600,20 720,50 C840,80 960,20 1080,50 C1200,80 1320,20 1440,50 L1440,100 L0,100 Z"
                fill="#7B3FF2" />
        </svg>
      </div>
    </section>
  );
};

export default Teachers;
